import React, { useEffect, useState } from "react";
import {
    Form,
    Input,
    Button,
    Select,
    Upload,
    DatePicker,
    InputNumber,
    Modal,
    Card,
    Row,
    Col,
    Tooltip,
    message,
} from "antd";
import {
    UploadOutlined,
    CloseOutlined,
    EyeOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import api from "../../../api";
import SuccessModal from "../Events/SuccessModal";

const { TextArea } = Input;
const { Option } = Select;

const adTypes = ["Banner", "Card", "Popup", "Carousel"];
const ctaTypes = ["Open URL", "Open App Screen", "Call", "None"];
const displayPositions = ["Top", "Middle", "Bottom", "Inline", "Popup"];

const targetScreens = [
    "Home",
    "News",
    "Marketplace – All Products"
];

const CreateMaster = ({ visible, onCancel, onSuccess, editdata }) => {
    const [form] = Form.useForm();
    const [fileList, setFileList] = useState([]);
    const [imagePreview, setImagePreview] = useState(null);
    const [previewVisible, setPreviewVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [isImageChanged, setIsImageChanged] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const targetScreen = Form.useWatch("target_screen", form);


    console.log("targetScreen", targetScreen)

    const filteredAdTypes =
        targetScreen === "Home"
            ? ["Banner", "Card"]
            : adTypes;

    // 📌 Upload


    const getImageSizeText = () => {
        switch (targetScreen) {
            case "Home":
                return "Upload Image (width 720-800 × height 400-460 px)";

            case "News":
                return "Upload Image (width 850–950 × height 1600–1700 px)";

            case "Marketplace – All Products":
                return "Upload Image (width 720-800 × height 400-460 px)";

            default:
                return "Select Target Screen First";
        }
    };
    const ctaTypeMap = {
        "Open URL": "Redirect",
        "Open App Screen": "Open App Screen",
        "Call": "Call",
        "None": "None"
    };


    const handleUploadChange = ({ fileList }) => {
        const file = fileList[0];

        // ✅ Ant Design sets status to undefined for ignored files
        // Only proceed if file is NOT ignored
        if (file && file.status !== "removed") {
            setImagePreview(URL.createObjectURL(file.originFileObj));
            setFileList([file]);
            setIsImageChanged(true);
        } else {
            setFileList([]);
            setImagePreview(null);
            setIsImageChanged(false);
        }
    };
    useEffect(() => {
        if (editdata) {
            form.setFieldsValue({
                advertiser_id: "1", // or map if available

                title: editdata.fld_ad_title,
                description: editdata.fld_ad_description,

                ad_type: editdata.fld_ad_type_name,

                cta_type: editdata.fld_cta_type_name,
                cta_label: editdata.fld_cta_label,
                cta_target: editdata.fld_cta_target,

                target_screen: editdata.fld_target_screen,
                display_position: editdata.fld_display_position,

                priority: Number(editdata.fld_display_priorty),

                start_date: editdata.fld_start_date
                    ? dayjs(editdata.fld_start_date, "MM/DD/YYYY")
                    : null,

                end_date: editdata.fld_end_date
                    ? dayjs(editdata.fld_end_date, "MM/DD/YYYY")
                    : null,

                status:
                    editdata.fld_ad_status === "active"
                        ? "Active"
                        : editdata.fld_ad_status === "inactive"
                            ? "Inactive"
                            : "Draft",
            });

            // ✅ image preview (VERY IMPORTANT)
            if (editdata.fld_image_path) {
                setImagePreview(editdata.fld_image_path);

                setFileList([
                    {
                        uid: "-1",
                        name: "advertisement.png",
                        status: "done",
                        url: editdata.fld_image_path,
                    },
                ]);

                setIsImageChanged(false); // ✅ existing image only
            }
        } else {
            form.resetFields();
            setFileList([]);
            setImagePreview(null);
        }
    }, [editdata]);

    const handleFinish = async (values) => {
        try {
            setLoading(true);

            const formData = new FormData();

            // ✅ IDs
            formData.append("fld_rf_id", editdata?.fld_rf_id || "");
            formData.append("fld_ad_sw_id", editdata?.fld_ad_sw_id || "");
            formData.append("fld_ad_id", editdata?.fld_ad_id || "");

            // ✅ Ad Details
            formData.append("fld_ad_title", values.title || "");

            formData.append(
                "fld_ad_description",
                values.description || ""
            );

            formData.append(
                "fld_ad_type_name",
                values.ad_type || "Banner"
            );

            formData.append(
                "fld_ad_type_id",
                adTypes.indexOf(values.ad_type || "Banner") + 1 + ""
            );

            // ✅ CTA
            formData.append(
                "fld_cta_label",
                values.cta_label || ""
            );

            formData.append(
                "fld_cta_type_id",
                values.cta_type && values.cta_type !== "None"
                    ? ctaTypes.indexOf(values.cta_type) + 1 + ""
                    : "0"
            );

            formData.append(
                "fld_cta_type_name",
                values.cta_type
                    ? ctaTypeMap[values.cta_type]
                    : "None"
            );

            formData.append(
                "fld_cta_target",
                values.cta_target || ""
            );

            // ✅ Screen & Position
            formData.append(
                "fld_target_screen",
                values.target_screen || "home"
            );

            formData.append(
                "fld_display_position",
                values.display_position || "top"
            );

            formData.append(
                "fld_display_priorty",
                values.priority
                    ? values.priority.toString()
                    : "1"
            );

            // ✅ Dates
            formData.append(
                "fld_start_date",
                values.start_date.format("MM/DD/YYYY")
            );

            formData.append(
                "fld_end_date",
                values.end_date.format("MM/DD/YYYY")
            );

            // ✅ Status
            formData.append(
                "fld_ad_status",
                values.status.toLowerCase()
            );

            // ✅ Geo
            formData.append("fld_geo_x", "");
            formData.append("fld_geo_y", "");

            // ✅ Form Completion
            formData.append(
                "fld_is_full_form_completed_form",
                "1"
            );

            formData.append("fld_q_id", "");

            // ✅ Time
            formData.append(
                "fld_form_start_time",
                dayjs().format("YYYY-MM-DD HH:mm:ss")
            );

            formData.append(
                "fld_form_end_time",
                dayjs().format("YYYY-MM-DD HH:mm:ss")
            );

            // ✅ User
            formData.append(
                "fld_loggedin_user_id",
                "admin"
            );

            formData.append(
                "fld_data_source",
                "mobile"
            );

            formData.append(
                "fld_app_version",
                "1.0"
            );

            // ✅ IMAGE FILE
            // ✅ NEW IMAGE UPLOADED
            if (isImageChanged && fileList[0]?.originFileObj) {
                formData.append(
                    "fld_image_path",
                    fileList[0].originFileObj
                );
            }

            // ✅ EDIT MODE → KEEP OLD IMAGE URL
            else if (!isImageChanged && editdata?.fld_image_path) {
                formData.append(
                    "fld_image_path",
                    editdata.fld_image_path
                );
            }

            // ✅ Meta
            formData.append(
                "synceddatetime",
                dayjs().format("YYYY-MM-DD HH:mm:ss")
            );

            formData.append("formcode", "101");
            formData.append("apikey", "kavin");
            formData.append("apptypeno", "1");
            formData.append("appversion", "1.0.0.0");


            const res = await api.masterCreation(formData);

            if (res?.data?.status === "1") {
                setShowSuccessModal(true);

                form.resetFields();
                setFileList([]);
                setImagePreview(null);
            } else {
                messageApi.error(
                    res?.data?.responsemessage || "Failed"
                );
            }
        } catch (err) {
            console.error(err);
            messageApi.error("Something went wrong");
        } finally {
            setLoading(false);
        }
    };
    const handleCloseSuccess = () => {
        setShowSuccessModal(false);

        form.resetFields();
        setFileList([]);
        setImagePreview(null);

        onSuccess(); // 🔥 refresh parent AFTER closing modal
    };


    const validateImageDimensions = (file) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            const objectUrl = URL.createObjectURL(file);

            img.onload = () => {
                const isHomeScreen = targetScreen === "Home";
                const isNewsScreen = targetScreen === "News";
                const isMarketPlace = targetScreen === "Marketplace – All Products"

                if (isHomeScreen) {
                    const validWidth = img.width >= 720 && img.width <= 800;
                    const validHeight = img.height >= 400 && img.height <= 460;
                    if (!validWidth || !validHeight) {
                        messageApi.error(
                            "For Home screen, image width must be 720–800 px and height must be 400–460px"
                        );
                        reject(false);
                        return;
                    }
                } else if (isNewsScreen) {
                    const validWidth = img.width >= 850 && img.width <= 950;
                    const validHeight = img.height >= 1600 && img.height <= 1700;

                    if (!validWidth || !validHeight) {
                        messageApi.error(
                            "For News screen, image width must be 850–950px and height must be 1600–1700px"
                        );
                        reject(false);
                        return;
                    }
                } else if (isMarketPlace) {
                    const validWidth = img.width >= 720 && img.width <= 800;
                    const validHeight = img.height >= 400 && img.height <= 460;

                    if (!validWidth || !validHeight) {
                        messageApi.error(
                            "For MarketPlace screen, image width must be 720–800px and height must be 400–460px"
                        );
                        reject(false);
                        return;
                    }

                }

                resolve(true);
            };

            img.onerror = () => {
                messageApi.error("Invalid image file");
                reject(false);
            };

            img.src = objectUrl;
        });
    };

    return (
        <>
            {contextHolder}

            {showSuccessModal && (
                <SuccessModal
                    visible={showSuccessModal}
                    onClose={handleCloseSuccess}
                    title={
                        editdata
                            ? "Ad Updated Successfully"
                            : "Ad Created Successfully"
                    }
                    description={
                        editdata
                            ? "Your advertisement has been updated successfully."
                            : "Your advertisement has been created and published."
                    }
                />
            )}

            <Modal
                open={visible}
                onCancel={onCancel}
                footer={null}
                width={1000}
                centered
                closeIcon={<CloseOutlined />}
                styles={{
                    mask: {
                        backdropFilter: "blur(8px)",
                        background: "rgba(0,0,0,0.35)",
                    },
                }}
            >
                <Card>
                    <h2>{editdata ? "Edit Advertisement" : "Create New Advertisement"}</h2>

                    <Form layout="vertical" form={form} onFinish={handleFinish}>


                        <Col span={12}>
                            <Form.Item
                                name="target_screen"
                                label="Target Screen"
                                rules={[{ required: true }]}
                            >
                                <Select placeholder="Select screen">
                                    {targetScreens.map((s) => (
                                        <Option key={s}>{s}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>



                        {/* Row 1 */}
                        <Row gutter={16}>
                            {/* <Col span={12}>
                                <Form.Item
                                    name="advertiser_id"
                                    label="Ad ID"
                                    rules={[{ required: true, message: "Select advertiser" }]}
                                >
                                    <Select placeholder="Select advertiser">
                                        <Option value="1">User 1</Option>
                                    </Select>
                                </Form.Item>
                            </Col> */}

                            {/* Title */}
                            <Col span={24}>
                                <Form.Item
                                    name="title"
                                    label="Ad Title"
                                    rules={[
                                        { message: "Enter title" },
                                        { max: 100 },
                                    ]}
                                >
                                    <Input placeholder="Enter ad title (max 100 characters)" />
                                </Form.Item>
                            </Col>

                        </Row>


                        {/* Description */}
                        <Form.Item name="description" label="Description">
                            <TextArea
                                rows={3}
                                maxLength={2000}
                                placeholder="Enter ad description (optional)"
                            />
                        </Form.Item>

                        {/* Screen + Position */}




                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    name="ad_type"
                                    label="Ad Type"

                                >
                                    <Select placeholder="Select ad type">
                                        {filteredAdTypes.map((t) => (
                                            <Option key={t}>{t}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>

                            {({ getFieldValue }) =>
                                getFieldValue("target_screen") === "Marketplace – All Products" && (

                                    <Col span={12}>
                                        <Form.Item
                                            name="display_position"
                                            label="Display Position"
                                            rules={[{ required: true }]}
                                        >
                                            <Select placeholder="Select position">
                                                {displayPositions.map((p) => (
                                                    <Option key={p}>{p}</Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>)}

                        </Row>

                        {/* 🔥 Media Upload */}
                        <Form.Item label="Media Upload" required>
                            <div
                                style={{
                                    height: 200,
                                    border: "1px dashed #d9d9d9",
                                    borderRadius: 6,
                                    position: "relative",
                                }}
                            >
                                {imagePreview ? (
                                    <>
                                        <img
                                            src={imagePreview}
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                            }}
                                        />

                                        <div
                                            style={{
                                                position: "absolute",
                                                top: 8,
                                                right: 8,
                                                display: "flex",
                                                gap: 8,
                                            }}
                                        >
                                            <Tooltip title="Preview">
                                                <Button
                                                    shape="circle"
                                                    icon={<EyeOutlined />}
                                                    onClick={() => setPreviewVisible(true)}
                                                />
                                            </Tooltip>

                                            <Tooltip title="Remove">
                                                <Button
                                                    danger
                                                    shape="circle"
                                                    icon={<CloseOutlined />}
                                                    onClick={() => {
                                                        setImagePreview(null);
                                                        setFileList([]);
                                                        setIsImageChanged(false);
                                                    }}
                                                />
                                            </Tooltip>
                                        </div>
                                    </>
                                ) : (
                                    <Upload.Dragger
                                        beforeUpload={async (file) => {

                                            // ✅ Check target screen first
                                            if (!targetScreen) {
                                                messageApi.warning(
                                                    "Please select the Target Screen before uploading an image."
                                                );
                                                return Upload.LIST_IGNORE;
                                            }

                                            const isImage = file.type.startsWith("image/");

                                            if (isImage) {
                                                try {
                                                    await validateImageDimensions(file);

                                                    setImagePreview(URL.createObjectURL(file));
                                                    setFileList([{ originFileObj: file, name: file.name }]);
                                                    setIsImageChanged(true);
                                                } catch {
                                                    setFileList([]);
                                                    setImagePreview(null);
                                                    setIsImageChanged(false);
                                                    return Upload.LIST_IGNORE;
                                                }
                                            }

                                            return false; // prevent auto-upload
                                        }}
                                        onChange={({ fileList }) => {
                                            // ✅ Only handle removals here
                                            if (fileList.length === 0) {
                                                setFileList([]);
                                                setImagePreview(null);
                                                setIsImageChanged(false);
                                            }
                                        }}
                                        fileList={fileList}
                                        maxCount={1}
                                        showUploadList={false}
                                        style={{ height: "100%", border: "none" }}
                                    >
                                        <UploadOutlined style={{ fontSize: 24 }} />

                                        <p style={{ fontWeight: 500 }}>
                                            {getImageSizeText()}
                                        </p>

                                        <p style={{ color: "#999", fontSize: 12 }}>
                                            JPG, PNG supported
                                        </p>
                                    </Upload.Dragger>
                                )}
                            </div>
                        </Form.Item>





                        {/* CTA */}
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item shouldUpdate>
                                    {({ getFieldValue }) =>
                                        getFieldValue("cta_type") !== "None" && (
                                            <Form.Item name="cta_label" label="CTA Label">
                                                <Input placeholder="Eg: Buy Now / Learn More" />
                                            </Form.Item>
                                        )
                                    }
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    name="cta_type"
                                    label="CTA Type"
                                >
                                    <Select placeholder="Select CTA type">
                                        {ctaTypes.map((t) => (
                                            <Option key={t}>{t}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>


                        </Row>

                        <Form.Item shouldUpdate>
                            {({ getFieldValue }) =>
                                getFieldValue("cta_type") !== "None" && (
                                    <Form.Item name="cta_target" label="CTA Target">
                                        <Input placeholder="Enter URL / Screen / Phone" />
                                    </Form.Item>
                                )
                            }
                        </Form.Item>



                        {/* Priority */}
                        <Form.Item name="priority" label="Display Priority">
                            <InputNumber
                                min={1}
                                max={999}
                                style={{ width: "100%" }}
                                placeholder="1 - 999"
                            />
                        </Form.Item>

                        {/* Dates */}
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    name="start_date"
                                    label="Start Date"
                                    rules={[{ required: true }]}
                                >
                                    <DatePicker style={{ width: "100%" }} />
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item
                                    name="end_date"
                                    label="End Date"
                                    dependencies={["start_date"]}
                                    rules={[
                                        { required: true },
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (!value || value >= getFieldValue("start_date")) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject("End date must be after start date");
                                            },
                                        }),
                                    ]}
                                >
                                    <DatePicker style={{ width: "100%" }} />
                                </Form.Item>
                            </Col>
                        </Row>

                        {/* Status */}
                        <Form.Item
                            name="status"
                            label="Ad Status"
                            rules={[{ required: true }]}
                        >
                            <Select placeholder="Select status">
                                <Option value="Draft">Draft</Option>
                                <Option value="Active">Active</Option>
                                <Option value="Inactive">Inactive</Option>
                                {/* <Option value="Expired">Expired</Option> */}
                            </Select>
                        </Form.Item>

                        {/* Buttons */}
                        <Form.Item>
                            <Row justify="end">
                                <div style={{ display: "flex", gap: 20 }}>
                                    <Button
                                        onClick={onCancel}
                                        style={{ width: 140, height: 40 }}
                                    >
                                        Cancel
                                    </Button>

                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        loading={loading}
                                        style={{
                                            backgroundColor: "#1980B9",
                                            borderColor: "#1980B9",
                                            width: 140,
                                            height: 40,
                                        }}
                                    >
                                        {editdata ? "Update Advs." : "Create New Advs."}
                                    </Button>
                                </div>
                            </Row>
                        </Form.Item>

                    </Form>
                </Card>
            </Modal>

            {/* Preview */}
            <Modal
                open={previewVisible}
                footer={null}
                onCancel={() => setPreviewVisible(false)}
            >
                <img src={imagePreview} style={{ width: "100%" }} />
            </Modal>
        </>
    );
};

export default CreateMaster;